
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, getFirestore, Firestore } from "firebase/firestore";

// Configurazione specifica per il progetto 80 Voglia
// EXPORTED for use in authService (Secondary App Pattern)
export const firebaseConfig = {
  apiKey: "AIzaSyA5WHZrwcBcLbOr01TvcszGKZne7DEDIhA",
  authDomain: "app-80-voglia.firebaseapp.com",
  projectId: "app-80-voglia",
  storageBucket: "app-80-voglia.firebasestorage.app",
  messagingSenderId: "34592168207",
  appId: "1:34592168207:web:d25135209a2195c46e467a",
  measurementId: "G-NCSJ3LWWL5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics safely (can fail in some restricted environments or if IDB is closing)
let analytics;
try {
  analytics = getAnalytics(app);
} catch (e) {
  console.warn("Analytics initialization skipped:", e);
}

export const auth = getAuth(app);

// Initialize Firestore with Persistent Local Cache & Multi-Tab Support
// This prevents "Failed to obtain primary lease" by allowing multiple tabs
// to share the IndexedDB cache safely, and makes data load instantly on slow WiFi.
let dbInstance: Firestore;

try {
  dbInstance = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
  });
} catch (err: any) {
  // If "Firestore has already been initialized", we retrieve the existing instance.
  // Note: If the existing instance has persistence enabled, it might still crash,
  // but this is the best handling for HMR (Hot Module Replacement).
  if (err.code === 'failed-precondition' || err.message?.includes('already been initialized')) {
      dbInstance = getFirestore(app);
  } else {
      console.error("Firestore init error:", err);
      throw err;
  }
}

export const db = dbInstance;
